var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "wk0xo743na"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.725490 0 0 0 0 0.737255 0 0 0 0 0.745098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#wk0xo743na)",
    transform: "translate(-14 -173) translate(-4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M2.457 2.419L2.457 17.713 6.181 17.713 6.181 2.419zM8.183 2.419L8.183 17.713 11.907 17.713 11.907 2.419zM13.91 2.419L13.91 17.713 17.634 17.713 17.634 2.419z",
    transform: "translate(18 173)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowsIcon);
export default __webpack_public_path__ + "static/media/rows-icon.3c2647c149fdf39e94ac6d51b14a08e5.svg";
export { ForwardRef as ReactComponent };